import React, { useState, useEffect, useCallback } from 'react';

import ViewToggler from '../components/ViewToggler/ViewToggler';

import DeviceDashboard from '../components/DeviceInventoryDashboard/DeviceDashboard';
import DeviceDetails from '../components/DeviceDetails/DeviceDetails';

import { JOKI } from '../JOKI';

export default function DeviceInventoryView(props) {

    const [globalFilter, setFilter] = useState({});

    return (
        <div className="main-view">
            <div className="page-header-title-row">
                <h3>Device Inventory</h3>
            </div>

            <DeviceDashboardView globalFilter={globalFilter} permissions={props.permissions} display={true}/>
        </div>
    );
}

function DeviceDashboardView({ globalFilter, ...props }) {

    if (!props.display) return null;

    return (
        <div className="view-body">
            <DeviceDashboard globalFilter={globalFilter} />

            {<DeviceDetails globalFilter={globalFilter}  permissions={props.permissions}/>}
        </div>
    );
}
